var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-4/5 mr-4" }, [
    _c("input", {
      attrs: {
        id: "cohosts",
        type: "text",
        name: "cohosts",
        placeholder: "Search for a cohost.",
      },
      domProps: { value: _vm.value.name },
      on: {
        input: function ($event) {
          return _vm.update("name", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _vm.isSearching
      ? _c(
          "ul",
          { staticClass: "cohosts-dropdown", attrs: { value: _vm.value.id } },
          [
            _c(
              "button",
              {
                staticClass: "close-dropdown",
                on: {
                  click: function ($event) {
                    return _vm.closeDropdown()
                  },
                },
              },
              [_vm._v("x")]
            ),
            _vm._v(" "),
            _vm._l(_vm.searchedOrganizations, function (organization) {
              return _c("li", { key: organization.id }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.selectOrganization(organization)
                      },
                    },
                  },
                  [_vm._v(_vm._s(organization.name))]
                ),
              ])
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }